import { Component, Input, OnInit, ChangeDetectorRef, SimpleChanges, Optional, Inject } from '@angular/core';
import { InvestmentModel, InvestmentTaxModel } from '../investment.model';
import { ContactModel } from '../../contact/contact/contact.model';
import { EventEmitter } from '@angular/core';
import { Output, OnChanges } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { CoreComponent } from '../../../core/header/core.component';
import { consts } from '../../../consts';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import { ActualSelected, Utils } from '../../../shared/utils';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { AccountsAndTaxesModel } from '../../invoice/tickets/accountsandtaxes.model';
import { AccountingAccountsModel } from '../../accounting/accounting-accounts/accounting-accounts.model';
import { AccountingMovementsImportComponent } from '../../accounting/movements/import/accounting-movements-import.component';
import { InvestmentService } from '../investment.service';
import { AccountMovementsViewModel } from '../../accounting/models/accounting-movement.model';
import { SharedService } from '../../../shared/services/shared.service';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { ContactFormV2Component } from '../../../modules_v2/contacts/components/contact-form-v2/contact-form-v2.component';
import { ContactService } from '../../contact/contact/contact.service';
import { InvestmentDialogImportAccount } from './investment-dialog-importAccount.component';
import { map } from 'rxjs/operators';

@Component({
    selector: 'convfact-investment-form',
    templateUrl: './investment-form.component.html',
    styleUrls: ['./investment.component.css'],
    standalone: false
})
export class InvestmentFormComponent implements OnInit, OnChanges {

  @Input() investment: InvestmentModel;
  @Output() onSave = new EventEmitter<any>();
  @Input() errors: object;
  @Input() bankAccounts: BankAccountModel[] = [];
  @Input() accounts: AccountingAccountsModel[] = [];
  @Input() providers: ContactModel[] = [];
  @Input() accountsAndTaxes = new AccountsAndTaxesModel;

  taxes = Array<InvestmentTaxModel>();
  taxesToTheView: string[] = [];

  originEntity: string = consts.INVESTMENT_ENTITY;
  filePath: string = consts.INVESTMENT_FILE_PATH;

  loading = false;
  ready = false;

  contactCtrl: UntypedFormControl;
  filteredContacts: Observable<ContactModel[]>;

  imageTempUrl: any = '';

  readyLoadedFiles: boolean = null;

  public newContactLoaded = new BehaviorSubject<boolean>(true);
  public contactList: ContactModel[] = [];

  //AccountMovementes Import data
  flagImport: boolean = false;
  saved: boolean = false;
  movement: AccountMovementsViewModel;
  type: string;
  //-----------------------------

  constructor(
    public snackBar: MatSnackBar,
    private addFileService: AddFileService,
    private ref: ChangeDetectorRef,
    public investmentService: InvestmentService,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private contactService: ContactService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    @Optional() public dialogRefImport: MatDialogRef<AccountingMovementsImportComponent>,
    @Optional() public dialogRef: MatDialogRef<InvestmentFormComponent>,
  ) { }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  public change(value: string): void {

    this.investment.accountActivity = value;

    let accountNumber: string = value;

    if (accountNumber) {
      accountNumber = accountNumber.substring(0, 3);
    }

    this.investmentService.investmentAmortizationTable(accountNumber)
      .then((response: any) => {
        if (response) {
          this.investment.maximumLinealCoeficient = response.maximumLinearCoefficient;
          this.investment.maximumPeriod = response.maximumPeriodYears;
        } else {
          this.investment.maximumLinealCoeficient = 0;
          this.investment.maximumPeriod = 0;
        }
      });
  }

  filterContacts(val) {
    const self = this;
    for (const contact of this.providers) {
      if (contact.companyName == val) {
        self.investment.contactsUid = contact.uid;
        self.investment.provider = contact.companyName;
      }
    }

    return val ? this.providers.filter(s => s.companyName != null && s.companyName.toLowerCase().indexOf(val.toLowerCase()) === 0)
      : this.providers;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.investment && changes.investment.currentValue.pdf != undefined) {
      if (this.investment.pdf) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFilesPDF(this.investment.fileUid, this.originEntity).then(result => {
          this.loadPdfBlob(result);
          this.readyLoadedFiles = true;
        });
      }
    }
    if (changes.investment && changes.investment.currentValue.image != undefined) {
      if (this.investment.image) {
        this.readyLoadedFiles = false;
        this.addFileService.getImageFromFiles(this.investment.fileUid, this.originEntity).then(response => {
          this.createImageFromBlob(response);
          this.readyLoadedFiles = true;
        })
      }
    }
  }

  ngOnInit() {
    if (this.data != null) {
      this.flagImport = this.data.flagImport;
      this.movement = this.data.movement;
      this.type = this.data.type;
      this.movement.type = this.type;
      this.investment.manualMovement = this.data.movement;

      this.investment.accountActivity = this.movement.accountNumber;
      this.investment.dateStartWorking = this.movement.date;
      this.investment.dateBuy = this.movement.date;
      this.investment.totalWithoutTax = this.movement.amount;

      this.sharedService.checkIfAccountNumberExists(this.movement.accountNumber, this.movement.type).then(response => {
        this.investment.manualMovement.accountNumber = response;
      })


    }

    this.contactCtrl = new UntypedFormControl();
    this.filteredContacts = this.contactCtrl.valueChanges
      .pipe(
        map(contact => contact && typeof contact === 'object' ? contact.companyName : contact),
        map(name => this.filterContacts(name))
      );

    this.investment.typeInvestment = "Tabla AEAT";

    this.ready = true;
  }

  save(investment) {
    this.loading = true;
    let noError = true;

    //Se comenta debido a que se pueden añadir inversiones que no corresponden al año fiscal en curso
    /*if (!Utils.DateIsInFiscalYear(investment.dateBuy)) {
      noError = false;
      this.loading = false;
      this.displayInfo("La fecha de compra y el año fiscal seleccionado, no son el mismo.");
    }*/

    if (investment.maximumLinealCoeficient <= 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El coeficiente lineal máximo % no puede ser menos de 1.");
    }

    if (investment.totalWithoutTax <= 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El total (sin impuestos) no puede ser menos de 1.");
    }

    if (investment.maximumPeriod <= 0) {
      noError = false;
      this.loading = false;
      this.displayInfo("El periodo máximo (años) no puede ser menos de 1.");
    }

    // Default Values
    if (this.investment.contactsUid == null) {
      this.investment.contactsUid = consts.EMPTY_GUID;
    }

    if (noError) {
      if (this.data == null) {
        this.onSave.emit(investment);
      } else {
        this.saveData(investment);
      }
      this.loading = false;
    }
  }

  saveData = function (investment: InvestmentModel) {
    this.spinner = true;

    if (investment.uid == null) {
      investment.fiscalYear = parseInt(ActualSelected.yearSelected);
      investment.activityUid = ActualSelected.activitySelected;

      this.investmentService.addData(investment)
        .then(investment => {
          this.investment = investment;
          if (this.data != null) {
            this.spinner = false;
            this.saved = true;
          } else {
            this.spinner = false;
            this.returnToIndex();
          }
        },
          error => {
            //Si venimos de importar, y ya existe la inversión, preguntamos si queremos actualizar
            //la inversión ya existente
            if (error.error['message'].includes("ya se encuentra registrada") && this.data != null) {
              this.dialog.open(InvestmentDialogImportAccount, {
                // width: '20%',
                //height: '40%',
                data: {
                  dataImport: this.investment,
                }
              }).afterClosed().subscribe(result => this.closeDialog())
            } else {
              this.displayInfo(error.error['message']);
            }
          })
    } else {
      this.investmentService.editData(investment.uid, investment)
        .then(investment => {
          this.investment = investment;
          this.spinner = false;
          this.returnToIndex();
        })
        .catch(error => {
          this.spinner = false;
          this.displayError("Compruebe los campos obligatorios marcados en rojo")
        })
    }
  }

  createImageFromBlob(image: Blob) {
    const reader = new FileReader();
    if (image) {
      reader.readAsDataURL(image);
      reader.onloadend = () => {
        this.imageTempUrl = reader.result;
        this.ref.detectChanges();
      }
      this.ref.detectChanges();
    }
  }

  loadPdfBlob(data: Blob) {
    this.imageTempUrl = data;
    this.ref.detectChanges();
  }

  SetFileParameters(event): void {
    this.imageTempUrl = null;
    this.investment.image = event.Image;
    this.investment.pdf = event.PDF;
    this.investment.fileUid = event.FileUid;

    if (event.File) {
      this.createImageFromBlob(event.File);
    }

    if (event.PDF) {
      this.loadPdfBlob(event.File);
    }
  }

  checkImage() {
    if (this.investment.fileUid != null || this.investment.image || this.investment.pdf) {
      this.addFileService.getImageFromFiles(this.investment.fileUid, this.originEntity).then(response => {
        this.createImageFromBlob(response);
      })
    }
  }

  setTax(tax: InvestmentTaxModel) {
    tax.taxId = tax.id;
    this.investment.taxes.push(tax);
  }

  changeChips = function () {
    this.investment.taxes.forEach(tax => {
      this.investment.setTax(tax);
    });
  }

  calcularTotal(): number {
    let total: number = Number(this.investment.totalWithoutTax);

    if (this.investment.taxes != undefined) {
      this.investment.taxes.forEach(tax => {
        let aux: number = (tax.taxImport / 100) * this.investment.totalWithoutTax;
        total += aux;
        aux = 0;
      });
    }

    return Utils.GetValueWithDecimals(total);
  }

  closeDialog() {
    this.dialogRefImport.close(this.saved);
  }

  displayError(error: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(error, '', options);
  }

  public newContact(isExpense: boolean) {
    const contactScratch = new ContactModel();

    if (isExpense) {
      contactScratch.isProvider = true;
      contactScratch.isClient = false;
    } else {
      contactScratch.isProvider = false;
      contactScratch.isClient = true;
    }

    contactScratch.isPhysical = true;

    const dialogNewContact = ContactFormV2Component.open(this.dialog, { scratch: contactScratch });

    this.newContactLoaded.next(false);

    dialogNewContact
      .pipe(
        map(value => {
          if (value === undefined) {
            this.newContactLoaded.next(true);
          }
          return value;
        })
      )
      .subscribe(result => {
        if (result !== undefined) {
          this.contactService.getListProviders().then(response => {
            if (response.length === this.contactList.length) {
              this.providers = response;
              this.newContactLoaded.next(null);
            } else {
              this.providers = response;
              this.newContactLoaded.next(true);
            }
          }).catch(() => {
            this.newContactLoaded.next(true);
            this.displayInfo('Ha ocurrido un error inesperado al obtener el listado de contactos');
          });
        }
      });
  }

  onSelectTax(data: any) {
    this.setTax(this.accountsAndTaxes.taxes.filter(c => c.id == data)[0])
  }

  public onChangeDateBuy(event: MatDatepickerInputEvent<Date>) {
    if (event && event.value) {
      this.investment.dateStartWorking = event.value;
    }
  }

  public trackByIndex(i: number) { return i; }

}
